import { Component } from '@angular/core';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
    selector: 'app-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.scss'],
    standalone: false
})
export class ToastsComponent {
  constructor(public toastService: ToastService) {}
}
